<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>BUSINESSMAN'S STEER DECORATING ENTRY FORM</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center mb-4">{{ currentYear }} BUSINESSMAN'S STEER DECORATING ENTRY FORM</div>

        <div v-if="saved">
          <div class="subheading mx-4">
            <p>Your Registration has been entered. Rodeo tickets are available at <a href="https://www.renorodeo.com">www.renorodeo.com</a>.</p>
          </div>
        </div>
        <!-- <div v-else>
          <div class="subheading mx-4">
            <p>BSD is full. Try again next year. Rodeo tickets are available at <a href="https://www.renorodeo.com">www.renorodeo.com</a>.</p>
          </div>
        </div> -->
        <div v-else>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">SPONSOR</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company"
                      label="Company Name"
                      ref="focusName"
                      :rules="[v => !!v || 'Company Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.contact"
                      label="Contact"
                      :rules="[v => !!v || 'Contact is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.address"
                      label="Address"
                      :rules="[v => !!v || 'Address is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs10 md5>
                        <v-text-field
                          v-model="editedItem.city"
                          label="City"
                          :rules="[v => !!v || 'City is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 md2>
                        <v-text-field
                          v-model="editedItem.state"
                          label="ST"
                          mask="AA"
                          :rules="[v => !!v || 'State is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md5>
                        <v-text-field
                          v-model="editedItem.zip"
                          label="Zipcode"
                          mask="#####"
                          :rules="[v => !!v || 'Zip is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      :rules="[v => !!v || 'Primary Phone is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CREDIT CARD INFORMATION</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.number"
                      label="Credit Card Number"
                      :rules="[v => !!v || 'Credit Card Number is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.cardName"
                      label="Name on Card"
                      :rules="[v => !!v || 'Name on Card is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      v-model="editedItem.expire"
                      label="Expires"
                      mask="##/##"
                      return-masked-value
                      :rules="[v => !!v || 'Expires is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.cvv"
                      label="CVV"
                      mask="####"
                      :rules="[v => !!v || 'CVV is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.amount"
                      label="Amount"
                      :rules="[v => !!v || 'Amount is required']"
                      mask="###.##"
                      prefix="$"
                      readonly
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="red--text">Please indicate if you need the Steer Decorating Committee to furnish contestants for
                      your company by entering "TBF by SD" in the name field for each contestant.</span>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CONTESTANT #1</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.repOneName"
                      label="Contestant #1 Name"
                      :rules="[v => !!v || 'Contestant #1 name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="email"
                      label="Contestant #1 Email"
                      type="email"
                      v-model="editedItem.repOneEmail"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.repOnePhone"
                      label="Contestant #1 Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CONTESTANT #2</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.repTwoName"
                      label="Contestant #2 Name"
                      :rules="[v => !!v || 'Contestant #2 name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      prepend-icon="email"
                      label="Contestant #2 Email"
                      type="email"
                      v-model="editedItem.repTwoEmail"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.repTwoPhone"
                      label="Contestant #2 Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLEASE INDICATE PERFORMANCE CHOICES:</span>
                  </v-flex>
                  <v-flex xs12 md6>
                  <v-select
                    v-model="editedItem.prefNight1"
                    :items="dates"
                    item-text="text"
                    item-value="value"
                    label="1sr Choice"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    v-model="editedItem.prefNight2"
                    :items="dates"
                    item-text="text"
                    item-value="value"
                    label="2nd Choice"
                    required
                  ></v-select>
                </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    SATURDAY NIGHT {{ finalsDate }} IS THE FINALS!
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    DEADLINE FOR RETURNING APPLICATIONS & THE ENTRY FEE IS MAY 31th AT 5:00 PM.
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">Submit</v-btn>
          </v-card-actions>
        </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      saved: false,
      checkbox: false,
      dates: [],
      editedItem: {
        amount: '275.00'
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      finalsDate: '',
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
    this.getDates()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async getDates () {
      try {
        const response = await Api().get('bsd_dates/' + this.currentYear)

        const dates = response.data

        const selectDates = []
        let date = {}

        for (let i in dates) {
          if (dates[i].status === 'finals') {
            this.finalsDate = moment(String(dates[i].date)).format('MM/DD/YYYY')
          } else {
            date.value = dates[i].date
            date.text = dates[i].night
            selectDates.push(date)
            date = {}
          }
        }

        this.dates = selectDates
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear

        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_bsd', this.editedItem)
          this.editedItem = {}
          this.editedItem.amount = '275.00'

          this.saved = true
          this.snackbar.message = response.data.message + ' Congratulation, your entry has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bsd/ExternalForm.vue